import React from "react";
import PropTypes from "prop-types";
import GameActions from "./GameActions.jsx";
import screenfull from "screenfull";
import RePreroll from "../../helpers/gamescreen/rePreroll";
import games_played from "../../helpers/games_played";

class GameContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showLoadingIcon: true,
			isFullscreen: screenfull.isFullscreen
		};
		this.toggleFull = this.toggleFull.bind(this);
	}
	componentDidMount() {
		setTimeout(() => {
			this.setState({
				showLoadingIcon: false
			});
		}, this.props.SecondaryloadingScreenTime);
		if (screenfull.isEnabled) {
			screenfull.on("change", this.toggleFull);
		}
		RePreroll.store();
		setTimeout(() => {
			const gp = new games_played();
			gp.load();
			gp.pike();
			this.gp = gp;
		}, this.props.pike.Timeout);
	}
	componentWillUnmount() {
		if (screenfull.isEnabled) {
			screenfull.off("change", this.toggleFull);
		}
		if (this.gp) {
			this.gp.stopPlaytimeTracking();
		}
	}
	toggleFull() {
		this.setState({
			isFullscreen: screenfull.isFullscreen
		});
	}

	render() {
		return (
			<React.Fragment>
				{this.state.showLoadingIcon ? (
					<section className="loading loading--semivisible">
						<div className="loading-container">
							<img src={this.props.charging_url} />

							<div className="loader">
								<span className="dot dot_1" />
								<span className="dot dot_2" />
								<span className="dot dot_3" />
								<span className="dot dot_4" />
							</div>
							<span>{this.props.translate.loading}...</span>
						</div>
					</section>
				) : null}

				<iframe
					id="iframeplayer"
					src={this.props.gameInfo.embed_url}
					width="100%"
					height="100%"
					marginWidth="0"
					marginHeight="0"
					hspace="0"
					vspace="0"
					frameBorder="0"
					scrolling="no"
					webkitallowfullscreen="true"
					mozallowfullscreen="true"
					msallowfullscreen="true"
					allowFullScreen
				/>
				<GameActions
					{...this.props.gameInfo}
					cdn={this.props.cdn}
					translate={this.props.translate}
				/>
			</React.Fragment>
		);
	}
}
GameContainer.propTypes = {
	translate: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	gameInfo: PropTypes.shape({
		id: PropTypes.number,
		url: PropTypes.string,
		img: PropTypes.string,
		name: PropTypes.string,
		puntuation: PropTypes.number,
		type: PropTypes.string,
		zoom: PropTypes.bool,
		mobile: PropTypes.bool,
		size_y: PropTypes.number.isRequired,
		size_x: PropTypes.number.isRequired,
		embed_url: PropTypes.string.isRequired,
		SecondaryloadingScreenTime: PropTypes.number.isRequired
	}).isRequired,
	charging_url: PropTypes.string.isRequired,
	pike: PropTypes.shape({
		Timeout: PropTypes.number.isRequired,
		extraTimeout: PropTypes.number.isRequired
	}).isRequired,
	cdn: PropTypes.string.isRequired
};
GameContainer.defaultProps = {
	translate: {
		loading: "Loading"
	}
};
export default GameContainer;
